/* eslint-disable simple-import-sort/exports */
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { useBreakpoint } from './hooks/useBreakpoint/useBreakpoint';
import { useForwardRef } from './hooks/useForwardRef/useForwardRef';

export * from '@mui/material';
export * from '@mui/x-date-pickers';
export type {
  AutocompleteProps,
  CollapsibleSectionProps,
  DataGridColumn,
  DatePickerProps,
  MultiAutocompleteProps,
  PhotoEvidenceItem,
  SelectProps,
  ShareMethod,
  EvidenceSessionPhotoGalleryItem,
  TextFieldProps,
  ToggleOption,
} from './components';
export {
  StickyElement,
  StickyContainer,
  Alert,
  ActionRow,
  Autocomplete,
  AutocompleteRenderGroup,
  BackButton,
  BooleanIcon,
  BorderedLinearProgress,
  Button,
  Card,
  BottomFab,
  CardsListSkeleton,
  CenteredLoader,
  CollapsibleSection,
  ConfirmationButton,
  ConfirmationDialog,
  ConfirmationDrawer,
  ConfirmationFab,
  EvidenceSessionPhotoGallery,
  DataCard,
  DataCardItem,
  DataGrid,
  DateComparison,
  DataAttributeList,
  DatePicker,
  DetailsList,
  DetailsListItem,
  DocumentCard,
  DialogHeader,
  Drawer,
  SelectableTile,
  PhotoEvidenceGallery,
  SelectableCard,
  EvidenceImage,
  ExpandableIconButton,
  FilePicker,
  FloatingBox,
  PdfViewer,
  ShareModal,
  HeroMediaGrid,
  HiddenInput,
  Image,
  ImageCarousel,
  ImageOverlay,
  Instruction,
  ShareButton,
  Page,
  LinearProgress,
  ListSection,
  ListSkeletonLoader,
  ListTitleItem,
  MasonryMediaGallery,
  MediaDialog,
  MediaItem,
  ShowMore,
  Menu,
  NetworkOverrideSwitch,
  NetworkStatusAlert,
  DialogCloseButton,
  MultiAutocomplete,
  PriceChip,
  PhotoEvidenceList,
  PhotoEvidenceMultiSelectList,
  PhotoFilePicker,
  ProgressiveImage,
  ConfirmationIconButton,
  PulseDot,
  ResultIcon,
  Section,
  SectionContainer,
  Select,
  SelectDatePicker,
  Sidebar,
  TabPanel,
  StatCard,
  Footer,
  ChipList,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  TypographyIcon,
  Video,
} from './components';
export { Typography, type TypographyProps } from './components';
export { ThemeProvider } from './theme/theme';
export type {
  GridColDef,
  GridRowSelectionModel,
  GridFilterOperator,
} from '@mui/x-data-grid';
export {
  getGridStringOperators,
  getGridSingleSelectOperators,
  getGridDateOperators,
  getGridBooleanOperators,
  getGridNumericOperators,
  useGridApiRef,
} from '@mui/x-data-grid';
export const dateAdapter = AdapterDayjs;
export { DateTimePicker } from '@mui/x-date-pickers';
export { useForwardRef, useBreakpoint };
export * from './utils';
